import axios from "../axios-auth";
import orginal_axios from "axios";


export const incomeStatementService = {
    getIncomeStatementList,
    saveIncomeStatement,
    getIncomeStatementById,
    getIncomeStatementForPreview,
    exportIncomeStatementPreview,
    exportIncomeStatement,
    getIncomeStatementForPreviewByBranch,
};

function getIncomeStatementForPreview(incomeStatement) {
    // preview
    return axios.post("/auth/preview-income-statement", incomeStatement);
}

function getIncomeStatementForPreviewByBranch(incomeStatement) {
    // preview
    return axios.post("/auth/preview-income-statement-by-branch", incomeStatement);
}

function getIncomeStatementList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/income-statements", { params });
}

function saveIncomeStatement(incomeStatement) {
    if (!incomeStatement.id) {
        // new income statement
        return axios.post("/auth/income-statement", incomeStatement);
    } else {
        return axios.put("/auth/income-statement", incomeStatement);
    }
}

function getIncomeStatementById(id) {
    return axios.get("/auth/income-statement/" + id);
}

function exportIncomeStatementPreview(searchParams,shopCode) {
    let params = {
    };
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (shopCode) {
        params["shopCode"] = shopCode;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.isBranch) {
        params["isBranch"] = searchParams.isBranch;
    }
    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/preview-income-statement-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function exportIncomeStatement(id) {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/preview-income-statement-detail-excel/"+id,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}